import lo from 'lodash'

export const getUniqueDepts = (depts, concerned, shared) => {

  const getCollab = () => {
    if (shared && shared.hasOwnProperty('collaboration')) {
      return shared.collaboration
    } else {
      return []
    }
  }
  const sharedDepts = lo.union([concerned], getCollab())
  const uniqueDepts = depts.filter(dep =>
    !sharedDepts.includes(dep.name)
  )

  return uniqueDepts
}